import React from 'react';

// ── SHARED FORM HELPERS ──────────────────────────────────────────────────────
export function F({ label, value, onChange, placeholder, type = 'text' }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {label && <label className="form-label" style={{ marginTop: 0 }}>{label}</label>}
      <input className="input" type={type} value={value} placeholder={placeholder || ''} onChange={e => onChange(e.target.value)} />
    </div>
  );
}
export function FArea({ label, value, onChange, placeholder }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {label && <label className="form-label" style={{ marginTop: 0 }}>{label}</label>}
      <textarea className="input input--textarea" rows={3} value={value} placeholder={placeholder || ''} onChange={e => onChange(e.target.value)} />
    </div>
  );
}
export function FToggle({ label, value, onChange }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0' }}>
      <span style={{ fontSize: 13, color: 'var(--forest-dark)', flex: 1 }}>{label}</span>
      <div className="yes-no-toggle">
        <button className={`yn-btn ${value ? 'active' : ''}`} onClick={() => onChange(true)}>Yes</button>
        <button className={`yn-btn ${!value ? 'active' : ''}`} onClick={() => onChange(false)}>No</button>
      </div>
    </div>
  );
}
export function SectionHead({ children }) {
  return <div style={{ fontWeight: 700, fontSize: 12, color: 'var(--sage)', textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: 8, paddingTop: 10, borderTop: '1px solid var(--border-soft)' }}>{children}</div>;
}
export function SaveBtn({ onSave, saving, saved }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 4 }}>
      <button className="btn btn--primary" onClick={onSave} disabled={saving}>
        {saving ? 'Saving…' : 'Save'}
      </button>
      {saved && <span style={{ fontSize: 13, color: 'var(--forest)' }}>✓ Saved</span>}
    </div>
  );
}


